import { apiFactory, headers } from '~/src/dash/api/api-factory';
import {
  IBidderGroupLabel,
  transformBidderGroupLabelFromAPI,
} from '~/src/dash/api/bidder-group-label';
import { retryFunc } from '~/src/dash/api/console-api';
import { parseArray, parseString, transformModel } from '~/src/dash/api/resource-transforms';
import { Auth } from '~/src/dash/api/transform-auth';

export type BidderGroupAPIKey =
  | 'ID'
  | 'CreatedAt'
  | 'UpdatedAt'
  | 'DeletedAt'
  | 'PublisherID'
  | 'Name'
  | 'BidderIDs'
  | 'BidderGroupLabels';

export interface IBidderGroup {
  ID: string;
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: string;

  PublisherID: string;
  Name: string;
  BidderIDs: string;
  BidderCount?: number;
  BidderGroupLabels: IBidderGroupLabel[];
}

export const transformBidderGroup = transformModel<IBidderGroup>({
  ID: parseString(['ID', 'id']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  PublisherID: parseString(['PublisherID', 'publisher_id']),
  Name: parseString(['Name', 'name']),
  BidderIDs: parseString(['BidderIDs', 'bidder_ids']),
  BidderGroupLabels: parseArray(['BidderGroupLabels'], transformBidderGroupLabelFromAPI),
});

export const transformBidderGroupWrapper = (fromObj: any): IBidderGroup => {
  return transformBidderGroup(fromObj);
};

export const getBidderGroups = apiFactory({
  method: 'GET',
  headers,
  body: {
    core_section: 'settings',
    core_action: 'bidder_groups',
  },
  retryCount: 1,
  retryFunc,
  transformQuery: Auth.appendToken,
  transformResponse: (err: any, json: any) => {
    if (err) {
      return new Error((json && json.msg) || 'request failed');
    }
    return {
      bidderGroups: (json.BidderGroups || []).map(transformBidderGroup),
    };
  },
});

export const updateBidderGroups = apiFactory({
  method: 'PATCH',
  headers,
  body: {
    core_section: 'settings',
    core_action: 'bidder_groups',
  },
  retryCount: 1,
  retryFunc,
  transformQuery: Auth.appendToken,
  transformResponse: (err: any, json: any) => {
    if (err) {
      return new Error((json && json.msg) || 'request failed');
    }
    return {
      bidderGroups: (json.BidderGroups || []).map(transformBidderGroup),
    };
  },
});
